module.exports = __webpack_public_path__ + "img/BFB_BM_Header_Unterseite_BM2-Wirtschaft_Mobile.a3e74cf7.jpg";